import React from "react";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import Slider from "react-slick";
import CategoryLoading from "../../PlaceHolder/CategoryLoading";
import { useQuery } from '@tanstack/react-query';
import { listProducts } from "../../../network/product";
import { queryKeys } from "../../../services/react-query/queryKeys";
import HomeProductCard from "../../Comman/HomeProductCard";

const SampleNextArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{ ...style, display: "block", paddingRight: "22px", borderRadius: "50px" }}
    onClick={onClick}
  >
    <style>{`.slick-next:before { color: gray; }`}</style>
  </div>
);

const SamplePrevArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{ ...style, display: "block", borderRadius: "50px" }}
    onClick={onClick}
  >
    <style>{`.slick-prev:before { color: gray; }`}</style>
  </div>
);

const Product = ({ t, i18n }) => {
  const { data: productData, isLoading } = useQuery({
    queryKey: [queryKeys.listProducts, i18n, { page: 1 }],
    queryFn: () => listProducts({ page: 1 }),
    enabled: !!i18n,
  });

  if (isLoading) {
    return <CategoryLoading />;
  }

  const sliderWidth =
    productData?.data && productData?.data.length === 1 && window.innerWidth >= 800
      ? "20%"
      : productData?.data && productData?.data.length === 2 && window.innerWidth >= 800
        ? "40%"
        : productData?.data && productData?.data.length === 3 && window.innerWidth >= 800
          ? "60%"
          : productData?.data && productData?.data.length === 4 && window.innerWidth >= 400
            ? "80%"
            : "100%";

  const sliderStyles = {
    width: sliderWidth,
  };

  const settings = {
    speed: 500,
    slidesToShow: productData?.data && productData?.data.length < 5 ? productData?.data.length : 5,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: productData && productData.length < 4 ? productData.length : 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: productData && productData.length < 3 ? productData.length : 3,
          slidesToScroll: 1,
          initialSlide: 1,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: productData?.data && productData?.data.length < 2 ? productData?.data.length : 2,
          slidesToScroll: 1,
          initialSlide: 1,
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: productData?.data && productData?.data.length < 1 ? productData.length : 1,
          slidesToScroll: 1,
          initialSlide: 1,
          nextArrow: false,
          prevArrow: false,
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: productData?.data && productData?.data.length < 1 ? productData?.data.length : 1,
          slidesToScroll: 1,
          initialSlide: 1,
          nextArrow: false,
          prevArrow: false,
        }
      },
      {
        breakpoint: 280,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: false,
          prevArrow: false,
          dots: false,
        }
      }
    ]
  };

  return (
    <div className="container my-20" style={{ overflow: window.innerWidth <= 920 ? "hidden" : "" }}>
      <div className="text-center mb-10 max-w-[600px] mx-auto">
        <h1 data-aos="fade-up" className="text-3xl font-bold">
          {t('Product')}
        </h1>
        <p data-aos="fade-up" className="text-lg text-gray-400">
          {t('product_description')}   <Link className="text-decoration-none" to="/products">
            {t('See')}&nbsp;{t('More')}
          </Link>
        </p>
      </div>

      <div style={sliderStyles}>
        <Slider {...settings}>
          {productData?.data?.map((product, i) => (
            <HomeProductCard key={i} product={product} isLoading={isLoading} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default withTranslation()(Product);
